// export const apiBaseEndpoint = 'http://localhost:8000';
export const apiBaseEndpoint = "https://arc-api.scieverinc.com";
// export const apiBaseEndpoint = 'https://test-api.arc.com.np';
export const apiEndPoint = apiBaseEndpoint + "/api";
